import React from 'react';
import { useQuery } from '@apollo/client';
import {
  PartnerSearchContext,
  FetchEndCustomerContactsInPpcQueryVariables,
  FetchEndCustomerContactsInPpcQuery,
  EndCustomerContact,
} from '@css-xp/graphtypes/src/generated-types-new';
import { EccTable } from '@css-xp/ppc-ecc-table';
import { fetchEndCustomerContactsInPPC } from '../../queries/fetch-end-customer-contacts';

interface EndCustomerContactSearchProps {
  query: string;
  transactionAccountId: string;
  partnerSearchContext: string;
}

export const EndCustomerContactSearch = ({
  query,
  transactionAccountId,
  partnerSearchContext,
}: EndCustomerContactSearchProps) => {
  const { data, loading } = useQuery<FetchEndCustomerContactsInPpcQuery, FetchEndCustomerContactsInPpcQueryVariables>(
    fetchEndCustomerContactsInPPC,
    {
      variables: {
        searchParams: {
          query: query,
          transactionAccountId,
          partnerSearchContext: partnerSearchContext as PartnerSearchContext,
          isOrgSearchEnabled: true,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    }
  );

  const results = (data?.endCustomerContacts?.nodes || []) as EndCustomerContact[];

  return (
    <div data-testid="ecc-list" data-test-id="ecc-list">
      {<EccTable endCustomerContacts={results} isLoading={loading} />}
    </div>
  );
};
